import React, { useEffect, useState } from "react";
import { Button, Form, message, Input, Layout, Card, Modal, Slider, InputNumber, List } from "antd";
import { useNavigate } from "react-router-dom";
import { getListaPratiche, getPacchettiOperatore, recuperaPraticaOperatore, setPacchettoOperatore,  } from "../services/api";
import { LoadingOutlined } from "@ant-design/icons";
import logo from "./../assets/img/BAbianco.png";
import moment from "moment/moment";
const { innerWidth, innerHeight } = window;
const { Content, Header } = Layout;
const { Meta } = Card;

const HomeScreenOperatore = () => {
  const navigate = useNavigate();
  const [modalRecupera, setModalRecupera] = useState();
  const [packages, setPackages] = useState({
    conto: true,
    finanziamento: true,
  });
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [loadingPackage, setLoadingPackage] = useState(false);
  const [recuperaPratica, setRecuperaPratica] = useState();
  const [listaPratiche, setListaPratiche] = useState([]);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  const [loadingPratiche, setLoadingPratiche] = useState(false);
  const [pacchettoOnHover, setPacchettoOnHover] = useState(null);
  const [isInTransition, setIsInTransition] = useState(false);

  useEffect(() => {
    fetchPacchetti();

    const handleResize = () => {
      setInnerWidth(window.innerWidth);
      setInnerHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (recuperaPratica) {
      setListaPratiche([]);
      setLoadingPratiche(true)
      try {
        getListaPratiche()
          .then((data) => {
            setListaPratiche(data.pratiche);
          })
          .catch((error) => {
          })
          .finally(() => {
            setLoadingPratiche(false);
          });
      } catch (error) {
      }
    }

  }, [recuperaPratica]);

  const fetchPacchetti = async () => {
    setLoadingPackage(true);
    try {
      getPacchettiOperatore()
        .then((data) => {
          setPackages(data);
        })
        .catch((error) => {
        })
        .finally(() => {
          setLoadingPackage(false);
        });
    } catch (error) {
      message.error(error);
      setLoadingPackage(false);
    }
  };

  const goForward = (item) => {
    // const idButton = item.id;
    // setSelectedPackage(idButton);
    // setRecuperaPratica(false);
    // navigate('/info', { state: item });

    setLoadingNextPage(true);
    const data = {
      id_pacchetto: item.id,
    };
    try {
      setPacchettoOperatore(data)
        .then((res) => {
          localStorage.setItem("token", res.token);
          localStorage.setItem("id_pratica", res.id_pratica);
          navigate('/onboarding');
          // navigate("/conditions", { state: item });
        })
        .catch((error) => {
        })
        .finally(() => {
          setLoadingNextPage(false);
        });
    } catch (error) {
      message.error(error);
      setLoadingNextPage(false);
    }
  };

  const handleRecuperaPratiche = (pratica) => {
    setLoadingPratiche(true);
    const data = {
      id_pratica: pratica.id
    }
    recuperaPraticaOperatore(data)
      .then((response) => {
        localStorage.setItem("token", response.token);
        setLoadingPratiche(false);
        localStorage.setItem("id_pratica", response.id_pratica);
        setModalRecupera();
        navigate("/onboarding");
      })
      .catch((error) => {
        message.error(error);
      });
  }

  const handleMouseOver = (item) => {
    if (innerWidth > 700 && item.vista_aggiuntiva) {
      setPacchettoOnHover(item);
      setIsInTransition(true);
    }
  }

  const handleMouseClick = (item) => {
    if (item.vista_aggiuntiva) {
      setPacchettoOnHover(item);
      setIsInTransition(true);
    }
  }

  const handleMouseOut = () => {
    if (innerWidth > 700 && pacchettoOnHover && !isInTransition) {
      setPacchettoOnHover(null);
    }
  }

  const handleBackClick = () => {
    setIsInTransition(false);
    if (pacchettoOnHover) {
      setPacchettoOnHover(null);
    }
  }

  const handleTransitionEnd = (item) => {
    if (pacchettoOnHover && pacchettoOnHover.id == item.id) {
      setIsInTransition(false);
    }
  }

  return (
    <Layout style={{ height: "calc(100vh - 64px)", backgroundColor: "white" }}>
      <Header style={{ backgroundColor: "#003897", display: "flex", justifyContent: "center" }}>
        <div style={{ position: "absolute", left: 20, top: 0 }}>
          <img src={logo} alt="Banco Azzoaglio" width={160} style={{ padding: 5, marginBottom: 5/* , marginLeft: "-47px" */ }} />
        </div>
        <div style={{ color: "white", fontFamily: "Poppins-Regular", fontSize: 18, }}>
          Matricola: {localStorage.getItem('matricolaOperatore')} - {localStorage.getItem('nomeOperatore')} - {localStorage.getItem('nomeFiliale')}
        </div>
        <div style={{ position: "absolute", right: 20, top: 0 }}>
          {innerWidth < 700 ? (
            <div
              onClick={() => {
                setRecuperaPratica(true);
                setModalRecupera(true);
              }}
              style={{ cursor: "pointer", color: "white", fontFamily: "Poppins-Regular", fontSize: 12, textDecoration: "underline", marginRight: "-5px" }}
            >
              Pratiche in corso
            </div>
          ) : (
            <div
              onClick={() => {
                setRecuperaPratica(true);
                setModalRecupera(true);
              }}
              style={{ cursor: "pointer", color: "white", fontFamily: "Poppins-Regular", fontSize: 18, textDecoration: "underline" }}
            >
              Pratiche in corso
            </div>
          )}
        </div>
      </Header>
      <Content>
        <div className="pol-content-home" style={{}}>
          <div style={{ color: "#003897", fontFamily: "Poppins-SemiBold", fontSize: innerWidth < 700 ? 32 : 40, textAlign: "center", marginTop: 15 }}>Benvenuto!</div>
          <div style={{ color: "#003897", fontFamily: "Poppins-Regular", fontSize: innerWidth < 700 ? 18 : 22, textAlign: "center", padding: innerWidth < 700 ? 10 : 0, alignItems: "center", marginBottom: "3%" }}>Seleziona uno dei prodotti sottostanti in base ai tuoi interessi</div>
          {(loadingPackage || loadingNextPage) && (
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", alignItems: "center", marginTop: "3%", marginBottom: "3%" }}>
              <LoadingOutlined style={{ fontSize: "64px", color: "#023AAE" }} />
            </div>
          )}
          {!loadingPackage && !loadingNextPage && (
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", alignItems: "center" }}>
              {
                packages.length > 0 &&
                packages.map((item) => (
                  <div
                    id={item.id}
                    key={item.id}
                    className={!pacchettoOnHover ? 'cardPacchetto' : (innerWidth < 700 ? 'cardPacchetto' : (pacchettoOnHover.id == item.id ? 'cardPacchetto hover' : 'cardPacchetto nascosto'))}
                    style={{
                      display: 'flex',
                      width: innerWidth < 700 ? 350 : 575,
                    }}
                    onTransitionEnd={() => handleTransitionEnd(item)}
                    onMouseEnter={() => handleMouseOver(item)}
                    onMouseLeave={() => handleMouseOut()}
                  >
                    <div style={{ color: "#003897", fontFamily: "Poppins-Regular", fontSize: innerWidth < 700 ? 16 : 20, textAlign: "center" }}>
                      {/* {"Aprire un\n"} */}
                      <div style={{ fontFamily: "Poppins-SemiBold" }}>{item.nome}</div>
                      <br />
                    </div>
                    {
                      (!pacchettoOnHover || pacchettoOnHover.id != item.id) && (
                        <div style={{ flex: 1 }}>
                          <img src={`data:image/svg+xml;utf8,${encodeURIComponent(item.path_logo)}`} width={innerWidth < 700 ? 250 : 450} height={400} style={{}} />
                        </div>
                      )}

                    {innerWidth < 700 ?
                      !pacchettoOnHover && item.vista_aggiuntiva == "simulatore_deposito" ? (
                        <Button type="primary" style={{ fontFamily: "Poppins-Regular", fontSize: 16, height: 40, borderRadius: 20, backgroundColor: "#003897", borderWidth: 0, width: 120, marginTop: innerWidth < 700 ? 10 : 0 }} onClick={() => handleMouseClick(item)}>
                          Simula
                        </Button>) : (<div>
                          {pacchettoOnHover && pacchettoOnHover.id == item.id &&
                            <Button type="primary" style={{ fontFamily: "Poppins-Regular", fontSize: 16, height: 40, borderRadius: 20, backgroundColor: "#003897", borderWidth: 0, width: 120, marginTop: innerWidth < 700 ? 10 : 0, marginRight: 10 }} onClick={() => handleBackClick()}>
                              Indietro
                            </Button>
                          }
                          <Button type="primary" style={{ fontFamily: "Poppins-Regular", fontSize: 16, height: 40, borderRadius: 20, backgroundColor: "#003897", borderWidth: 0, width: 120, marginTop: innerWidth < 700 ? 10 : 0 }} onClick={() => goForward(item)}>
                            Apri Conto
                          </Button>
                        </div>) : (<Button type="primary" style={{ fontFamily: "Poppins-Regular", fontSize: 16, height: 40, borderRadius: 20, backgroundColor: "#003897", borderWidth: 0, width: 120, marginTop: innerWidth < 700 ? 10 : 0 }} onClick={() => goForward(item)}>
                          Apri Conto
                        </Button>)}


                  </div>
                ))
              }
            </div>
          )}
        </div>

        <Modal open={modalRecupera} footer={null} closable={false}>
          <div style={{ marginBottom: 80 }}>
            <div style={{ fontSize: 20, fontFamily: "Poppins-SemiBold" }}>Lista Pratiche in Corso</div>
            {recuperaPratica && (
              <div>
                {
                  loadingPratiche ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <LoadingOutlined style={{ fontSize: "34px", color: "rgb(0, 56, 151)", marginTop: 40 }} />
                    </div>
                    :
                    <List>
                      {
                        listaPratiche && listaPratiche.map((item, index) => {
                          let dateFormat = moment(item.data).format('DD/MM/YYYY')

                          return <div style={{ cursor: 'pointer' }}
                            key={item.id}
                            onClick={() => {
                              handleRecuperaPratiche(item);
                            }}>
                            <List.Item style={{ color: '#0049EA' }}>
                              {item.id} - {item.persona} - {dateFormat}
                            </List.Item>
                          </div>
                        })
                      }
                      {
                        listaPratiche && listaPratiche.length == 0 &&
                        <div style={{ marginBottom: 30, fontSize: 16, fontFamily: "Poppins-Regular", marginTop: 10 }}>Non ci sono pratiche recuperabili.</div>
                      }
                    </List>
                }


                {/* <div style={{ marginBottom: 30, fontSize: 16, fontFamily: "Poppins-Regular", marginTop: 10 }}>Inserisci il codice per recuperare la tua pratica</div> */}
                {/* <Form onFinish={recuperaHandler}>
                  <Form.Item
                    name="pratica"
                    label={<div style={{ color: "#0A69E8", fontSize: 20, fontFamily: "Poppins-Medium" }}>Codice Pratica</div>}
                    style={{ width: "80%" }}
                  // label="Codice Pratica"
                  >
                    <Input style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: "#0061DF", fontSize: 20, fontFamily: "Poppins-Regular", marginLeft: 20 }} />
                  </Form.Item>
                  <Button type="primary" htmlType="submit" style={{ backgroundColor: "#2574F2", height: 40, width: 100, borderRadius: 6, position: "absolute", right: 20, bottom: 20 }}>
                    {loading && (
                      <div>
                        <LoadingOutlined style={{ fontSize: "24px", color: "#023AAE" }} />
                      </div>
                    )}
                    {!loading && <div style={{ fontSize: 16, fontFamily: "Poppins-Regular" }}>AVANTI</div>}
                  </Button>
                </Form> */}
              </div>
            )}
            <Button
              onClick={() => {
                setRecuperaPratica();
                setModalRecupera();
              }}
              style={{ height: 40, width: 100, borderRadius: 6, position: "absolute", right: 20, bottom: 20 }}
            >
              <div style={{ fontSize: 16, fontFamily: "Poppins-Regular" }}>CHIUDI</div>
            </Button>
          </div>
        </Modal>
      </Content>
    </Layout>
  );
};

export default HomeScreenOperatore;
